var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-right",staticStyle:{"margin-top":"0px"}},[_c('a-spin',{attrs:{"spinning":_vm.detailSpinning}},[_c('detail-list',{attrs:{"article":_vm.article,"reviewInfo":_vm.reviewInfo},on:{"submitSuccess":_vm.getDetailInfo}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a2bcbce","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/documentItem/index.vue
// module id = null
// module chunks = 